module.exports = __webpack_public_path__ + "media/icons/default_icon-5eb2dfb9.svg";